/* Crafted Turtle — brand behavior
   Transparent-over-hero header on the homepage: positions the floating header
   just below the announcement bar, then solidifies it into a sticky bar once
   the user scrolls past the top. No-ops on pages without the overlay header. */
(function () {
  var overlay = document.querySelector('.header-wrapper--overlay');
  if (!overlay) return;

  var bar = document.querySelector('.utility-bar');
  var root = document.documentElement;

  function measure() {
    var h = bar ? bar.offsetHeight : 0;
    root.style.setProperty('--ct-overlay-top', h + 'px');
  }

  function onScroll() {
    overlay.classList.toggle('header-scrolled', window.scrollY > 40);
  }

  measure();
  onScroll();
  window.addEventListener('resize', measure);
  window.addEventListener('scroll', onScroll, { passive: true });
})();
